export enum TasksModule {
  CIL,
  DEFECTTAG,
  CHECKLIST,
  ACTIONPLAN,
}
